import { parseUnicode } from '../../../../models/commonModels';
import styles from './CommentView.module.css'
import { Avatar } from 'antd';
export const CommentViewItem = ({icon,uname,emoji}:{icon:string, uname:string, emoji:string}) =>{
    return(
    <div className={styles.comment_view_menu_item}>
                                     <Avatar size={32} icon={<img src={icon}/>} />
                                    <div style={{flex:"1"}}>{uname}</div>
                                    <div>{parseUnicode(emoji)}</div>
                                </div>
    )
}